import InvestmentsPage from './InvestmentsPage';

export default InvestmentsPage;